import React from 'react'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { DcButton, PixelFactoryContext, PixelIcon } from 'pixel-base'
import styled from 'styled-components'

import { deleteCustomerPaymentMethod } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../../../decl.d'

interface IPaymentMethod {
  card_number: string
  card_type: string
  created_at: string
  cvc: string
  expiry_date: string
  method_name: string
  method_type: string
  name_on_account: string
  payment_method_id: number
  account_id: string
  account_number: string
}
interface Iprops {
  data: IPaymentMethod
  customer_id: any
  onDelete: any
}
const PaymentMethod = (props: Iprops) => {
  const { data, customer_id } = props
  const {
    showPageLoader,
    hidePageLoader,
    showSuccess,
    showFailure,
    pixelConfirm,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)
  const handleDelete = () => {
    pixelConfirm({
      title: 'Delete Address',
      message:
        'Are you sure? you want to delete this, This action cannot be undone.',
      onConfirm: () => {
        showPageLoader()
        deleteCustomerPaymentMethod(customer_id, data.id).subscribe(
          (res: any) => {
            hidePageLoader()
            if (res.response === true) {
              showSuccess('Payment method deleted successfully')
              props.onDelete(data.id)
            } else {
              showFailure(
                `Something went wrong, ${res.response.message_detail}`,
              )
            }
          },
        )
      },
    })
  }
  return (
    <PaymentMethods>
      <PaymentMethodsActions>
        <DcButton
          onClick={handleDelete}
          variant="outline-danger"
          size="sm"
          tooltip="Delete"
          className="red"
        >
          <PixelIcon color="inherit" icon={faTrash} className="delete" />
        </DcButton>
      </PaymentMethodsActions>
      <CardRow>
        <CardInfo>
          <Label>Name</Label>
          <Value>{data.name_on_account}</Value>
        </CardInfo>

        <CardInfo flexEnd>
          {data.method_type === 'card' ? (
            <>
              <Label>Number</Label>
              <Value>{data.card_number}</Value>
            </>
          ) : data.method_type === 'bank' ? (
            <>
              <Label>Number</Label>
              <Value>{data.account_number}</Value>
            </>
          ) : (
            <>
              <Label>Account ID</Label>
              <Value>{data.account_id}</Value>
            </>
          )}
        </CardInfo>
      </CardRow>
      <Divider />
      <CardRow>
        <CardInfo>{data.expiry_date}</CardInfo>
        <CardInfo flexEnd>{data.card_type}</CardInfo>
      </CardRow>
    </PaymentMethods>
  )
}

const PaymentMethodsActions = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  align-content: center;

  .red {
    color: #ff0000;
  }
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
`
const PaymentMethods = styled.div`
  display: flex;
  flex-direction: columns;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  max-width: 300px;
  padding: 10px 20px;
  background: transparent;
  color: #000;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
  margin-bottom: 15px;
  cursor: pointer;
  border-radius: 3px;
  position: relative;
  &:hover {
    ${PaymentMethodsActions} {
      opacity: 1;
    }
  }
`
const CardRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
`
const CardInfo = styled.div<{ flexEnd?: boolean }>`
  align-self: ${(props) => (props.flexEnd ? 'flex-end' : 'flex-start')};
`
const Label = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #2f3c4d;
  margin-bottom: 5px;
`
const Value = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #2f3c4d;
  margin-bottom: 5px;
`
const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e9ecef;
  margin: 10px 0px;
`
export default PaymentMethod
